import { useEffect } from "react";

export default function useScrollOrNavigate() {
    useEffect(() => {
        const pendingScroll = sessionStorage.getItem("pendingScroll");
        if (pendingScroll) {
            const { targetPage, targetId } = JSON.parse(pendingScroll);
            const currentPath = window.location.pathname;

            if (currentPath.includes(targetPage)) {
                const section = document.getElementById(targetId);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth", block: "start" });
                }
                sessionStorage.removeItem("pendingScroll");
            }
        }
    }, []);

    const handleScrollOrNavigate = (targetId, targetPath) => {
        const currentPath = window.location.pathname;

        if (currentPath === targetPath) {
            const section = document.getElementById(targetId);
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        } else {
            sessionStorage.setItem(
                "pendingScroll",
                JSON.stringify({ targetPage: targetPath, targetId })
            );
            window.location.href = targetPath; // Or router.push(targetPath) if using Next.js
        }
    };

    return handleScrollOrNavigate;
}
